import React, { useState } from 'react';
import dynamicFunction from '../utils/dynamicfunction';
import Text from './Text';
import { fontSizes } from '../constants/constants';
import ViewReverse from './ViewReverse';
import { ReactSVG } from 'react-svg';
import icons from '../constants/icons';

const CustomInput = ({
  type = 'text',
  value,
  onChange,
  isFullborder = true,
  isRounded = false,
  placeholder,
  isError = false,
  className,
  label,
  labelColor = 'text-primary-light',
  divClasses,
  isRequired = false,
  errorMessage,
  isDisabled = false,
  width = 'w-full',
  isPassword,
  maxLength,
  pattern,
  border,
  onPressEnter,
  canEnterSpace = true,
  props,
}) => {
  const { TextWeight, TextAlign } = dynamicFunction();
  const [isSecure, setIsSecure] = useState(true);

  const arabicRegix = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0660-\u0669]/g;

  const handleChange = (e) => {
    const clenedText = e?.target?.value?.replace(arabicRegix, '');
    const value = {
      target: {
        value: clenedText,
      },
    };
    onChange(value);
  };

  return (
    <div className={`${width} ${divClasses}`}>
      <Text
        text={label && label}
        size={fontSizes.h14}
        color={isError ? 'text-red-500' : labelColor}
        className={`mb-1`}
        isRequired={isRequired}
        isTruncate={false}
      />
      <ViewReverse
        className={`px-3 py-2 ${border ?? (isFullborder ? 'border' : 'border-b-2')} ${isError ? 'border-red-600' : 'border-grey'} ${
          isRounded ? 'rounded' : ''
        } w-full h-[40px] ${className} ${isDisabled && 'opacity-50'}`}
      >
        <input
          type={isPassword ? (isSecure ? 'password' : 'text') : type}
          value={value}
          onChange={handleChange}
          disabled={isDisabled}
          placeholder={placeholder}
          className={`${TextWeight.light} ${TextAlign} outline-none w-full text-sm`}
          maxLength={maxLength}
          pattern={pattern}
          onKeyDown={(e) => {
            if (e.key === ' ' && !canEnterSpace) {
              e.preventDefault();
              return;
            }
            e.key === 'Enter' && onPressEnter && onPressEnter();
          }}
          onInput={(e) => {
            if (!canEnterSpace) {
              const value = e.target.value;
              if (value.endsWith('. ')) {
                e.target.value = value.slice(0, -2);
              }
            }
          }}
          {...props}
        />
        {isPassword && (
          <>
            <ReactSVG
              src={isSecure ? icons.hidePassword : icons.showPassword}
              className='cursor-pointer'
              onClick={() => !isDisabled && setIsSecure(!isSecure)}
            />
          </>
        )}
      </ViewReverse>
      {errorMessage && (
        <Text
          text={errorMessage}
          color='text-red-500'
          className={'mt-2'}
          weight={TextWeight.light}
        />
      )}
    </div>
  );
};

export default CustomInput;
